import { Link } from "react-router-dom";
import Sidebar from "../../StudentPanel/StudentSidebar/Sidebar";
import StudentNavbar from "../StudentNavbar/StudentNavbar";
import RoutesPath from "../../Utils/RoutesPath";
import { Button, Card } from "react-bootstrap";
import { useContext, useEffect, useRef, useState } from "react";
import StudentDashboardServices from "../../Services/StudentDashboardApiService";
import { handleApiErrors } from "../../Utils/Utils";
import SubmitButtonTwo from "../../Components/Reusable/Buttontwo";
import { toast } from "react-toastify";
import { AuthContext } from "../../Context/authContext";
import ApiConstants from "../../Utils/ApiConstant";
import Image from "../../Components/Reusable/Image";
import { CirclesWithBar, RotatingLines } from 'react-loader-spinner'; // Import the loader from react-loader-spinner
import SessionManager from "../../Utils/Session";
import { PngImages } from "../../Utils/LocalImages";

const StudentDashboard = () => {
  const [packageData, setPackagesData] = useState([]);
  const { user, updateUserCartCount } = useContext(AuthContext);
  const [searchQuery, setSearchQuery] = useState(null);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(9);
  const [loading, setLoading] = useState(false);
  const [loadingTwo, setLoadingTwo] = useState(null);
  const [hasMore, setHasMore] = useState(true);


  const loader = useRef(null);

  useEffect(() => {
    SessionManager.shared.getData();
  }, [])

  const getAllPackages = async (newOffset = 0) => {
    setLoading(true);
    try {
      const response = await StudentDashboardServices.getAllPackages(
        newOffset,
        limit,
      );

      setPackagesData(prevPackages => [...prevPackages, ...response.packages]);
      setHasMore(response.packages.length === limit);
    } catch (error) {
      handleApiErrors(error);
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (subject) => {

    if (subject.isPurchased) {
      toast.error("Package Already Purchased!");
      return;
    }
    setLoadingTwo(subject.package_id);

    try {
      const response = await StudentDashboardServices.addToCart(
        subject.package_id
      );
      updateUserCartCount(response.cartData.cartCount);
      if (response.message == "Success") {
        toast.success("Package Added Successfully!");
      }
      else {
        toast.success(response.message);

      }
    } catch (error) {
      handleApiErrors(error);
    } finally {
      setLoadingTwo(null);
    }
  };


  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && hasMore && !loading) {
          setOffset(prevOffset => prevOffset + 1);
          getAllPackages(offset);
        }
      },
      {
        root: null,
        rootMargin: "20px",
        threshold: 1.0
      }
    );

    if (loader.current) {
      observer.observe(loader.current);
    }

    return () => {
      if (loader.current) {
        observer.unobserve(loader.current);
      }
    };
  }, [hasMore, loading, offset]);

  const truncateText = (text, charLimit) => {
    if (!text) return "";
    return text.length > charLimit ? text.substring(0, charLimit) + "..." : text;
  };
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="mainLayout-content">
        <StudentNavbar />
        <div className="main_content contentSection scroll_bar">
          <div className="mb-4 d-flex justify-content-between align-items-center">
            <h1 className="black sub-large-text-one fw-700 mb-0"> Purchase Packages</h1>
          </div>
          <div>
            {loading && packageData.length === 0 ? (
              <div className="text-center d-flex justify-content-center">
                <CirclesWithBar
                  height="80"
                  width="80"
                  color="#F6821F"
                  ariaLabel="bars-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </div>
            ) : packageData.length > 0 ? (
              <div className="row">
                {packageData.map((subject, index) => (
                  <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-6 col-12 d-flex py-4" key={index}>
                    <Card className="border-0 bg-transparent mx-0 gap-1" style={{ width: '100%' }}>
                      <div className="packagecardimagesize">
                        <Image
                          className="card-img-top Packagecardimage"
                          src={
                            subject?.mainImage && subject.mainImage?.trim() !== ""
                              ? ApiConstants.FILE_FETCH_URL + subject.mainImage
                              : ""
                          }
                        />
                      </div>
                      <Card.Body className="bg-transparent Packagetitle px-0">
                        <Card.Title className="large-text fw-700 text-capitalize" style={{ height: "80px" }} title={subject.packageName}>{truncateText(subject.packageName, 75)}</Card.Title>
                        <Card.Text className="hrline text-end ">
                          <Link to={`${RoutesPath.packagedetails}/${subject.package_id}`}>
                            <p className="small-medium-text fw-600 mb-2" style={{ color: "#F6821F" }}>
                              Package Details &nbsp;{">"}
                            </p>
                          </Link>
                        </Card.Text>
                        {!subject.isPurchased &&
                          <div className="d-flex gap-3 pt-1">
                            <span className="disprice Small-Heading fw-600">
                              &#x20b9;{subject.discountedPrice}
                            </span>
                            {subject.actualPrice === subject.discountedPrice ? null :
                              <div className="originalprice medium-text fw-400 pb-1">
                                &#x20b9;{subject.actualPrice}
                              </div>}
                          </div>}

                      </Card.Body>
                      {loadingTwo == subject.package_id ? (
                        <div className="text-center d-flex justify-content-center">
                          <RotatingLines
                            height="25"
                            width="25"
                            strokeColor="#F6821F"
                            ariaLabel="bars-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                          />
                        </div>
                      ) : (
                        <SubmitButtonTwo
                          title={subject.isPurchased ? 'Purchased' : 'Add To Cart'}
                          className="addtocardbtn"
                          onclick={() => onSubmit(subject)}
                        />
                      )}
                    </Card>
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-records-container text-center">
                <div className="no-record-image">
                  <Image src={PngImages.no_record} className="img-fluid" />
                </div>
                <p className="no-records-text sub-large-text-one fw-700 mb-4">No records found</p>
              </div>
            )}
            {!loading && hasMore && (
              <div ref={loader} style={{ height: '1px' }}></div>
            )}



          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentDashboard;

